import type { ProposalDetails } from './types'
import SFetch from '@app/utils/sfetch'

export * from './types'

export async function update(
  id: number,
  details: ProposalDetails
): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_proposal_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    id
  )

  await SFetch.json(url, {
    method: 'PATCH',
    body: { details },
  })
}

export async function accept(id: number): Promise<void> {
  const url = window.Silverfin.Routes.accept_client_meetings_proposal_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    id
  )

  await SFetch.raw(url, {
    method: 'POST',
  })
}

export async function reject(id: number): Promise<void> {
  const url = window.Silverfin.Routes.reject_client_meetings_proposal_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    id
  )

  await SFetch.raw(url, {
    method: 'POST',
  })
}
